import {
  getStickyHeaderHeight,
  getMainSubheaderHeight,
  getSecondarySubheaderHeight,
  getSystemBannerHeight,
} from '@app/utils/domHelpers'

export const getTableTopOffset = (table: HTMLElement): number =>
  table.getBoundingClientRect().top + window.scrollY - getHeaderOffset()

export const getTableBottomOffset = (table: HTMLElement): number =>
  table.getBoundingClientRect().bottom + window.scrollY - getHeaderOffset()

export const getHeaderOffset = (): number => {
  return [
    getStickyHeaderHeight(),
    getMainSubheaderHeight(),
    getSecondarySubheaderHeight(),
    getSystemBannerHeight(),
  ].reduce((acc, height) => {
    return acc + parseInt(height.replace('px', ''), 10)
  }, 0)
}
